import React from "react";

import { searchStructuralUnits } from "@/api/one_c_pickers";
import { LoadState } from "@/lib/scan-ui/screen";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";

/** Настройки инвентаризации: организации и склады, которые можно считать. */
export function InventorySettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader
          title="Инвентаризация"
          subtitle="Организации раздела и склады, которые можно инвентаризовать."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader
        title="Инвентаризация"
        subtitle="Организации раздела и склады, которые можно инвентаризовать."
      />
      <OrgWhitelistCard
        title="Организации в разделе «Инвентаризация»"
        field="inventory_org_refs"
        current={data.inventory_org_refs}
      />
      <OrgWhitelistCard
        title="Склады, которые можно инвентаризовать"
        field="inventory_warehouse_refs"
        current={data.inventory_warehouse_refs}
        searchFn={(q) => searchStructuralUnits("Склад", q)}
        queryKey="inv-warehouses"
        entityLabel="склады"
      />
    </div>
  );
}
